export const getQueryOptions = ({
  databaseFieldId,
  birthdayRange,
  maxTotalNumberOfItems = undefined,
  startOrEndOfCurrentYear,
  collectionFilters = [],
}) => ({
  limit: maxTotalNumberOfItems,
  filters: [
    ...collectionFilters,
    {
      column: databaseFieldId,
      value: {
        range: [birthdayRange.start, birthdayRange.end],
      },
      type: "DATE",
      condition: "IS",
      isInDashboard: true,
      recurring: true,
    },
    // {
    //   column: databaseFieldId,
    //   value: { range: [undefined, startOrEndOfCurrentYear] },
    //   type: "DATE",
    //   condition: "IS",
    //   isInDashboard: true,
    //   recurring: false,
    // },
    { isMultiUser: true, type: "BOOLEAN", value: true, column: "hidden", condition: "NOT" },
  ],
  sort: {
    fieldId: databaseFieldId,
    order: "asc",
    fieldPrefix: "date_field_recurring",
  },
});
